import request from "../../utils/Request";

// ------------------  API接口地址  ------------------ 
/** api地址 */

// ------------------  API调用接口  ------------------ 

/**获取会议室下的广告信息 */
export const loginAndPlayView = (data) => {
    return request.Get(`/pad/meeting/getPadAdInfo`)
}

/**根据模型id获取数据 */
export const getUserStationList = (modelId) => {
    return request.Get(`/pad/meeting/userStationList`)
}

/**登录 */
export const getlogin = (src) => {
    return request.jsonPost(`/api/digitalData/pad/sys/login`, src)
}
/**获取用户 */
export const getUserListForPad = () => {
    return request.Get(`/digitalData/pad/sys/getUserListForPad`)
}
/**退出 */
export const getlogout = () => {
    return request.Get(`/digitalData/pad/sys/logout`)
}

/**会议室列表 */
export const getlist = (data?: any) => {
    if (data) {
        return request.Get(`/pad/meeting/list?roomCode=${data}`)
    } else {
        return request.Get(`/pad/meeting/list`)
    }
}

/**获取会议室下的广告信息 */
export const getPadAdInfo = (meetingRoomId) => {
    return request.Get(`/pad/meeting/getPadAdInfo?meetingRoomId=${meetingRoomId}`)
}

/**获取会议室下的预约记录 */
export const padAppointmentRecordList = (roomCode) => {
    return request.Get(`/pad/meeting/padAppointmentRecordList?roomCode=${roomCode}`)
}


